import React, { useRef, useEffect, useState } from "react";
import Form from "react-bootstrap/Form";
import "./liveLocation.scss";
import Header from "../../components/header/Header";
import Footer from "../../components/footer/Footer";
import PageHeading from "../../components/pageHeading/PageHeading";
import { Button, Col, Row } from "react-bootstrap";
// import LocationMap from '../../assets/images/location-map.png'
import {
  LiveLocationIcon,
  PickupLocationIcon,
  SearchIcon,
} from "../../components/Icons";
import {
  GoogleMap,
  LoadScript,
  Marker,
  StandaloneSearchBox,
  DirectionsRenderer,
  Autocomplete,
  useJsApiLoader,
} from "@react-google-maps/api";
import { GOOGLE_MAPS_API_KEY, toast_warning } from "../../config/Constant";
import MovingDetails from "../../modals/movingDetails/MovingDetails";
import SuccessModal from "../../modals/successModal/SuccessModal";
import { toast_error } from "../../config/Constant";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { setLoader } from "../../slice/commonSlice";
import { createJob, fetchSavedAddress } from "../../services/auth.service";
import SelectDateTime from "../selectDateTime/SelectDateTime";
import SavedAddress from "../../modals/savedAddress/SavedAddress";
import Map from "./Map";
import moment from "moment";
import { fetchProviderDetails } from "../../services/hireProvider.service";
import { getFullName, twoDecimalPlaces } from "../../utils/common";
import { selectUser } from "../../slice/authSlice";

const Livelocation = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const pickupLocationRef = useRef(null);
  const dropLocationRef = useRef(null);
  const [successModal, setSuccessModal] = useState(false);
  const [successResponse, setSuccessResponse] = useState({});
  const id = location.state?.providerId;
  const [mannual, setMannual] = useState(false);
  const [routeDetails, setRouteDetails] = useState({
    distance: null,
    durationInMin: null,
    durationInHour: null,
  });
  const [jobDescription, setJobDescription] = useState("");
  const [startPlace, setStartPlace] = useState(null);
  const [endPlace, setEndPlace] = useState(null);
  const [directions, setDirections] = useState(null);
  const [formModal, setFormModal] = useState(false);
  const [senderDetails, setSenderDetails] = useState({});
  const [receiverDetails, setReceiverDetails] = useState({});
  const [pickupTime, setPickupTime] = useState(null);
  const [pickupDay, setPickupDay] = useState(null);
  const [timeModal, setTimeModal] = useState(false);
  const [savedAddressModal, setSavedAddressModal] = useState(false);
  const [savedAddressList, setSavedAddressList] = useState([]);
  const [saveSender, setSaveSender] = useState(false);
  const [saveReceiver, setSaveReceiver] = useState(false);
  const [type, setType] = useState("");
  const [profile, setProfile] = useState();
  const startRef = useRef();
  const endRef = useRef();
  const libraries = ["places"];
  const mapOptions = {
    disableDefaultUI: true,
  };
  // const [couponId, setCouponId] = useState();
  // const [discountType, setDiscountType] = useState();
  // const [couponDiscount, setCouponDiscount] = useState();
  // const [couponCode, setCouponCode] = useState("");

  const handlePlaceChangedStart = () => {
    const place = startRef.current.getPlace(); // Get the selected place

    if (place && place.formatted_address) {
      setStartPlace(place);
      const sender = {
        address: place.formatted_address,
      };
      console.log("sender", sender); // Should log the sender object
      setSenderDetails(sender);
    } else {
      console.log("No formatted address found.");
    }
  };
  const handlePlaceChangedEnd = () => {
    if (endRef.current) {
      // Get the selected place
      const place = endRef.current.getPlace();

      if (place && place.formatted_address) {
        setEndPlace(place); // Update state with the selected place
        const receiver = {
          address: place.formatted_address, // Capture the address
        };
        console.log("Receiver:", receiver); // Debugging: Check the receiver object
        setReceiverDetails(receiver); // Set the receiver details in state
      } else {
        console.log("No valid place selected");
      }
    }
  };

  const senderData = useSelector(selectUser);
  console.log("User data:", senderData);

  useEffect(() => {
    if (id) {
      getProfile();
    }
  }, [id]);

  const getProfile = async () => {
    let payload = {
      _id: id,
    };
    await dispatch(setLoader(true));
    try {
      const response = await fetchProviderDetails(payload);
      await dispatch(setLoader(false));
      if (response.status) {
        setProfile(response.data);
      }
    } catch (error) {
      await dispatch(setLoader(false));
      console.error("Error fetching data:", error);
    }
  };
  function addTimeAndFormatISO(dateObj, timeObj) {
    const time = moment(timeObj).format("HH:mm:ss");
    const momentDate = moment(dateObj);
    const year = momentDate.year();
    const month = momentDate.month();
    const day = momentDate.date();

    const combinedDateTime = moment.tz(
      `${year}-${month + 1}-${day} ${time}`,
      "YYYY-MM-DD HH:mm",
      "Atlantic/Bermuda"
    );

    console.log("Combined DateTime (Bermuda):", combinedDateTime.format());

    return combinedDateTime.format();
  }

  const handleSubmit = async (selectedCardId, jobDesc ,couponId,discountType,couponDiscount,couponCode ) => {
    if (!selectedCardId) {
      toast.error("Please select credit card to proceed further");
    }
    let payload = {
      unitPrice: location.state?.unitPrice,
      startTime: addTimeAndFormatISO(pickupDay, pickupTime),
      durationExpected: routeDetails?.durationInHour,
      distance: routeDetails?.distance,
      serviceId: location?.state?.serviceId,
      serviceName: location?.state?.serviceName,
      jobType: location?.state?.jobType,
      providerId: id,
      saveSenderAddress: saveSender,
      saveReceiverAddress: saveReceiver,
      sender: senderDetails,
      receiver: receiverDetails,
      paymentProfileId: selectedCardId,
      jobDetail: jobDesc,
    };

    if (couponId) {
      payload.couponId = couponId;
      payload.discountType = discountType;
      payload.couponDiscount = couponDiscount;
      payload.couponCode = couponCode;
    }

    // console.log(" payload.couponId", payload.couponId)

    await dispatch(setLoader(true));
    try {
      const response = await createJob(payload);
      await dispatch(setLoader(false));
      if (response.data.status) {
        // setSenderDetails(null);
        // setReceiverDetails(null);
        setStartPlace(null);
        setEndPlace(null);
        handleClearInputFields();
        setSuccessModal(true);
        setSuccessResponse(response.data);
      } else {
        toast.error(response?.data?.message, toast_error);
      }
    } catch (error) {
      await dispatch(setLoader(false));
      console.error("Error fetching data:", error);
    }
  };
  useEffect(() => {
    if (startPlace && endPlace) {
      calculateDistance();
    }
  }, [startPlace, endPlace]);
  const calculateDistance = () => {
    if (window.google && startPlace && endPlace) {
      const directionsService = new window.google.maps.DirectionsService();

      directionsService.route(
        {
          origin: startPlace.geometry.location,
          destination: endPlace.geometry.location,
          travelMode: window.google.maps.TravelMode.DRIVING,
        },
        (result, status) => {
          if (status === window.google.maps.DirectionsStatus.OK) {
            const route = result.routes[0];
            const leg = route.legs[0];

            // Distance in kilometers
            const distanceInKm = leg.distance.text;
            const distanceInMeter = leg.distance.value;
            // console.log('Distance:', distanceInKm);
            // console.log('Distance meter:', leg.distance.value);

            // Duration in seconds
            const durationInSeconds = leg.duration.value;
            // console.log('Duration in seconds:', durationInSeconds);

            // Convert duration to minutes
            const durationInMinutes = durationInSeconds / 60;
            // console.log('Duration in minutes:', durationInMinutes);

            // Convert duration to hours and minutes
            const durationInhours = durationInMinutes / 60;
            // console.log('Duration in hr:', durationInhours);
            setRouteDetails({
              durationInMin: durationInMinutes,
              durationInHour: durationInhours,
              distance: distanceInKm,
              distanceInMeter: distanceInMeter,
            });
            setDirections(result);
          } else {
            console.error(`Error fetching directions: ${status}`);
          }
        }
      );
    }
  };

  const mapStyles = {
    height: "400px",
    width: "100%",
  };

  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: GOOGLE_MAPS_API_KEY,
    libraries,
  });

  const handleContinue = (status) => {
    if (status) {
      setSenderDetails(null);
      setReceiverDetails(null);
      setStartPlace(null);
      setEndPlace(null);
    }
    setMannual(status);
    setFormModal(true);
  };

  const handleCloseAddress = () => {
    setSavedAddressModal(false);
    setFormModal(true);
  };

  const handleCloseTimeModal = async(
    e,
    selectedCardId,
    jobDesc,
    couponId,
    discountType,
    couponDiscount,
    couponCode
  ) => {
     if (e) {
      if (couponId) {
            console.log("couponId====>",couponId)
      // setCouponId(couponId);
      // setDiscountType(discountType);
      // setCouponDiscount(couponDiscount);
      // setCouponCode(couponCode);
      setTimeModal(false);
      setFormModal(false);
      setJobDescription(jobDesc);
     await handleSubmit(selectedCardId, jobDesc,couponId,discountType,couponDiscount,couponCode);
    }else{
      setTimeModal(false);
      setFormModal(false);
      setJobDescription(jobDesc);
     await handleSubmit(selectedCardId, jobDesc);
    }
      
    } else {
      setSenderDetails(null);
      setReceiverDetails(null);
      setStartPlace(null);
      setEndPlace(null);
      setTimeModal(false);
      setFormModal(false);
      setSaveSender(false);
      setSaveReceiver(false);
    }
  };

  const handleTimeModal = () => {
    setTimeModal(true);
    setFormModal(false);
  };

  const handleSavedAddressModal = (type) => {
    if (type) {
      setType(type);
      getSavedAddress(type);
    }
  };

  const getSavedAddress = async (type) => {
    await dispatch(setLoader(true));
    try {
      const response = await fetchSavedAddress(type);
      await dispatch(setLoader(false));
      if (response.data.status) {
        setSavedAddressList(response.data.data);
        if (response.data.data?.length > 0) {
          setSavedAddressModal(true);
        } else {
          toast.warning("No saved address found", toast_warning);
        }
      }
    } catch (error) {
      await dispatch(setLoader(false));
      console.error("Error fetching data:", error);
    }
  };

  const handleClearInputFields = () => {
    pickupLocationRef.current.value = "";
    dropLocationRef.current.value = "";
  };
  return (
    <>
      <Header />
      <PageHeading
        title={getFullName(
          profile?.personData?.firstName,
          profile?.personData?.lastName
        )}
      />

      <div className="main-container">
        <div className="container-wrap">
          <div className="location-tracker-wrapper">
            <div className="w-100 add-manual-wrap">
              <span onClick={() => handleContinue(true)}>
                Add Manually Data
              </span>
            </div>
            <div className="box-wrapper location-tracker-wraper">
              <Row className="g-3">
                <Col md={5} className="location-search-wrap ">
                  <div className="check-wrap">
                    <PickupLocationIcon />
                  </div>
                  <div className="search-wrap">
                    {isLoaded ? (
                      <Autocomplete
                        onLoad={(ref) => (startRef.current = ref)}
                        onPlaceChanged={handlePlaceChangedStart}
                        options={{
                          componentRestrictions: { country: "BM" }, // Restricting search to Bermuda
                          fields: ["formatted_address", "geometry"], // Specify the fields you need
                        }}
                      >
                        <Form.Control
                          type="text"
                          ref={pickupLocationRef}
                          placeholder="Select Pickup Location"
                        />
                      </Autocomplete>
                    ) : null}

                    <div className="icon-wrap">
                      <SearchIcon />{" "}
                    </div>
                  </div>
                </Col>
                <Col md={7} className="location-address-wrap">
                  <div className="icon-wrap">
                    <LiveLocationIcon />
                  </div>
                  <div className="location-address">
                    {isLoaded ? (
                      <Autocomplete
                        onLoad={(ref) => (endRef.current = ref)}
                        onPlaceChanged={handlePlaceChangedEnd}
                        options={{
                          componentRestrictions: { country: "BM" }, // Restricting search to Bermuda
                          fields: ["formatted_address", "geometry"], // Specify the fields you need
                        }}
                      >
                        <Form.Control
                          type="text"
                          ref={dropLocationRef}
                          placeholder="Select Delivery Location"
                        />
                      </Autocomplete>
                    ) : null}
                  </div>
                  <div className="btn-wrap">
                    <Button
                      variant="primary"
                      onClick={() => handleContinue(false)}
                    >
                      Continue
                    </Button>
                  </div>
                </Col>
              </Row>
              <div className="location-tracker-map">
                {/* <img src={LocationMap} alt='Location Map' /> */}

                {isLoaded ? (
                  <>
                    {/* <GoogleMap options={mapOptions} mapContainerStyle={mapStyles} center={{ lat: 0, lng: 0 }} zoom={12}>
                      {startPlace && <Marker position={startPlace?.geometry?.location} />}
                      {endPlace && <Marker position={endPlace?.geometry?.location} />}
                      {directions && (
                        <DirectionsRenderer
                          directions={directions}
                          options={{ suppressMarkers: true }}
                        />
                      )}
                    </GoogleMap> */}
                    <Map
                      startPlace={startPlace}
                      endPlace={endPlace}
                      directions={directions}
                    />
                  </>
                ) : null}
                {startPlace && endPlace && routeDetails ? (
                  <>
                    <p>
                      {routeDetails?.distance}, (
                      {twoDecimalPlaces(routeDetails?.durationInMin)} min)
                    </p>
                  </>
                ) : null}
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
      {formModal ? (
        <MovingDetails
          senderData={senderData}
          formModal={formModal}
          setFormModal={setFormModal}
          senderDetails={senderDetails}
          receiverDetails={receiverDetails}
          setSenderDetails={setSenderDetails}
          setReceiverDetails={setReceiverDetails}
          startPlace={startPlace}
          endPlace={endPlace}
          routeDetails={routeDetails}
          setStartPlace={setStartPlace}
          setEndPlace={setEndPlace}
          mannual={mannual}
          handleTimeModal={handleTimeModal}
          handleSavedAddressModal={handleSavedAddressModal}
          setSaveSender={setSaveSender}
          setSaveReceiver={setSaveReceiver}
          handleClearInputFields={handleClearInputFields}
        />
      ) : null}
      {timeModal ? (
        <SelectDateTime
          unitPrice={location.state?.unitPrice}
          timeModal={timeModal}
          setTimeModal={setTimeModal}
          setPickupTime={setPickupTime}
          setPickupDay={setPickupDay}
          pickTime={pickupTime}
          handleCloseTimeModal={handleCloseTimeModal}
          senderDetails={senderDetails}
          receiverDetails={receiverDetails}
          routeDetails={routeDetails}
          id={id}
        />
      ) : null}
      {savedAddressModal ? (
        <SavedAddress
          setStartPlace={setStartPlace}
          setEndPlace={setEndPlace}
          savedAddressModal={savedAddressModal}
          setSavedAddressModal={setSavedAddressModal}
          savedAddressList={savedAddressList}
          setSenderDetails={setSenderDetails}
          setReceiverDetails={setReceiverDetails}
          type={type}
          handleCloseAddress={handleCloseAddress}
        />
      ) : null}
      {successModal ? (
        <SuccessModal
          type="moving"
          sender={senderDetails}
          receiver={receiverDetails}
          providerId={id}
          serviceName={location.state?.serviceName}
          setSuccessModal={setSuccessModal}
          successModal={successModal}
          successResponse={successResponse}
        />
      ) : null}
    </>
  );
};

export default Livelocation;
